import { MetricTarget } from '../../enum';
import { DOUBLE_HYPHEN } from '../wizard/workArrivalPattern/selectors';
export var PERIOD_REPORT_ROWS = {
  forecastedDemand: 'forecastedDemand',
  weightedAht: 'weightedAht',
  serviceLevelForecast: 'serviceLevelForecast',
  asa: 'asa',
  abandonmentRate: 'abandonmentRate',
  occupancy: 'occupancy',
  occOrProd: 'occupancyOrProductivity',
  shrinkage: 'shrinkage',
  attrition: 'attrition',
  productiveHours: 'productiveHours',
  workloadHours: 'workloadHours',
  productionHours: 'productionHours',
  productionFte: 'productionFte',
  productiveFte: 'productiveFte',
  requiredFte: 'requiredFte',
  requiredHeadcount: 'requiredHeadcount',
  requiredAgents: 'requiredAgents',
  supportStaff: 'supportStaff',
  agentsSalaries: 'agentsSalaries',
  supportStaffSalaries: 'supportStaffSalaries',
  costPerWork: 'costPerWork',
  hiringAhead: 'hiringAhead',
  overtimeCosts: 'overtimeCosts',
  totalBudgets: 'totalBudgets',
  totalSupportStaff: 'totalSupportStaff',
  totalSupportStaffSalaries: 'totalSupportStaffSalaries',
  seatsRequired: 'seatsRequired'
};
export var ONE_DECIMAL_VALUE = ['serviceLevelForecast', 'abandonmentRate', 'attrition', 'occupancy', 'shrinkage', 'requiredAgents', 'productionFte', 'requiredFte', 'supportStaff', 'totalSupportStaff'];
export var ONLY_SINGLE_QUEUE = ['serviceLevelForecast', 'asa'];
export var STAFF_REQUIREMENT_ROWS = ['forecastedDemand', 'serviceLevelForecast', 'asa', 'occupancy', 'abandonmentRate', 'productionHours', 'requiredAgents', 'requiredFte', 'requiredHeadcount', 'supportStaff', 'totalSupportStaff'];
export var STAFF_REQUIREMENT_ROWS_PROD_HOURS = ['occupancy', 'shrinkage', 'attrition', 'productiveHours', 'productionHours', 'productionFte', 'requiredFte', 'requiredHeadcount', 'supportStaff', 'totalSupportStaff'];
export var WORKLOAD_AND_PERFORMANCE_ROWS = ['forecastedDemand', 'weightedAht', 'serviceLevelForecast', 'asa', 'occupancy', 'abandonmentRate', 'workloadHours', 'productionHours'];
export var QUEUE_ONLY_PERIOD_HIERARCHY_ROWS = ['weightedAht', 'serviceLevelForecast', 'asa', 'occupancy', 'abandonmentRate'];
export var AGENT_REQUIREMENTS_ROWS = ['productionFte', 'requiredFte', 'requiredHeadcount'];
export var SEATS_REQUIRED_ROWS = ['seatsRequired'];
export var SUPPORT_STAFF_ROWS = ['supportStaff', 'totalSupportStaff'];
export var STAFF_BUDGET_ROWS = ['agentsSalaries', 'supportStaffSalaries', 'hiringAhead', 'overtimeCosts', 'totalBudgets'];
export var STAFF_BUDGET_WITH_LOCATIONS_ROWS = ['totalBudgets'];
export var AGENTS_SALARIES_ROWS = ['agentsSalaries'];
export var SUPPORT_STAFF_SALARIES_ROWS = ['supportStaffSalaries'];
export var HIRING_AHEAD_ROWS = ['hiringAhead'];
export var COST_ROWS = ['costPerWork'];
export var PERCENTAGES = ['serviceLevelForecast', 'abandonmentRate', 'occupancy', 'shrinkage'];
/**
 * Queue-row Average column: prefer API `summary` (backend volume-weighted) via
 * `pickPeriodSummaryAverage`. Not used for the plan-level MainRow for every key — see
 * `PERIOD_MAIN_ROW_SUMMARY_AVERAGE_KEYS`.
 */
export var PERIOD_SUMMARY_AVERAGE_KEYS = ['serviceLevelForecast', 'abandonmentRate', 'occupancy', 'asa', 'requiredAgents'];
/**
 * Plan-level MainRow only: pass `data.summary` into the Average column for true plan rollups.
 * Queue-only metrics (SL, ASA, occupancy, abandonment) stay blank on the parent row when
 * monthly plan series are empty; their weighted averages apply on QueueRow only.
 */
export var PERIOD_MAIN_ROW_SUMMARY_AVERAGE_KEYS = ['requiredAgents'];
/** Prefer API volume-weighted chunk average for period table Average column when present. */
export function pickPeriodSummaryAverage(keyItem, apiChunk, simpleMean) {
  if (PERIOD_SUMMARY_AVERAGE_KEYS.includes(keyItem)) {
    if (apiChunk != null && apiChunk !== '') {
      var n = Number(apiChunk);
      if (!Number.isNaN(n)) return n;
    }
  }
  return Number.isNaN(simpleMean) ? DOUBLE_HYPHEN : simpleMean;
}
export var CURRENCY = ['agentsSalaries', 'supportStaffSalaries', 'hiringAhead', 'overtimeCosts', 'totalBudgets', 'costPerWork'];
export var CURRENCY_DECIMAL_VALUE = {
  costPerWork: 2
};
export var getCurrencyDecimalValue = function (valueKey) {
  var _a;
  return (_a = CURRENCY_DECIMAL_VALUE[valueKey]) !== null && _a !== void 0 ? _a : 0;
};
export var HIDE_ROW = ['forecastedDemand', 'productionHours', 'requiredAgents', 'requiredFte', 'requiredHeadcount', 'supportStaff', 'agentsSalaries', 'supportStaffSalaries', 'serviceLevelForecast', 'asa', 'abandonmentRate', 'occupancy', 'weightedAht', 'workloadHours', 'productionFte', 'productiveFte', 'hiringAhead', 'totalBudgets', 'seatsRequired'];
export var TOTAL_DATA = ['totalSupportStaff', 'totalSupportStaffSalaries'];
export var ONLY_PLAN_DATA = ['overtimeCosts'];
export var RESOURCING_CHARTS = ['requiredAgents', 'totalSupportStaff'];
export var FINANCIAL_CHARTS = ['totalBudgets', 'avgCostPerWork'];
export var metricTargetMap = {
  asa: MetricTarget.ASA,
  occupancy: MetricTarget.Occupancy,
  serviceLevelForecast: MetricTarget.ServiceLevel
};
export var DECIMAL_VALUE_MAP = {
  requiredAgents: 1,
  totalSupportStaff: 1,
  avgCostPerWork: 2
};